// Global UI actions
export const LOADING                                = 'LOADING';
export const RESET_LOADING                          = 'RESET_LOADING';
export const LOGIN                                  = 'LOGIN';
export const RECEIVE_RESET_PASSWORD                 = 'RECEIVE_RESET_PASSWORD';
export const CLEAR_PASSWORD_RESET                   = 'CLEAR_PASSWORD_RESET';
export const CLEAR_LOGIN_FAILED                     = 'CLEAR_LOGIN_FAILED';

// Security
export const RECEIVE_DEFAULT_PASSWORD_CONFIGURATION = 'RECEIVE_DEFAULT_PASSWORD_CONFIGURATION';

// Utilities
export const SHOW_MESSAGE_BOX                       = 'SHOW_MESSAGE_BOX';
export const CLEAR_MESSAGE_BOX                      = 'CLEAR_MESSAGE_BOX';

// General Info
export const RECEIVE_GENERAL_INFO                   = 'RECEIVE_GENERAL_INFO';

// API Console
export const RECEIVE_API_METHODS                    = 'RECEIVE_API_METHODS';

// Repeat Tester
export const RECEIVE_CALCULATED_TASK_REPEAT         = 'RECEIVE_CALCULATED_TASK_REPEAT';
export const RECEIVE_TASK_INFO                      = 'RECEIVE_TASK_INFO';
export const CLEAR_REPEATS                          = 'CLEAR_REPEATS';

// Enterprise Maintenance
export const RECEIVE_ENTERPRISE_LIST                = 'RECEIVE_ENTERPRISE_LIST';
export const RECEIVE_ENTERPRISE_INFO                = 'RECEIVE_ENTERPRISE_INFO';
export const RECEIVE_ENTERPRISE_ROLES               = 'RECEIVE_ENTERPRISE_ROLES';
export const RECEIVE_ENTERPRISE_USERS               = 'RECEIVE_ENTERPRISE_USERS';
export const CLEAR_ENTERPRISE_USERS                 = 'CLEAR_ENTERPRISE_USERS';
export const CLEAR_ENTERPRISE_INFO                  = 'CLEAR_ENTERPRISE_INFO';

// Roles
export const RECEIVE_ROLES                          = 'RECEIVE_ROLES';

// Permissions
export const RECEIVE_PERMISSIONS                    = 'RECEIVE_PERMISSIONS';

// Users
export const RECEIVE_USER_INFO                      = 'RECEIVE_USER_INFO';
export const RECEIVE_IMPERSONATED_USERS             = 'RECEIVE_IMPERSONATED_USERS';
export const UPDATE_USER                            = 'UPDATE_USER';
export const ERROR_UPDATE_USER                      = 'ERROR_UPDATE_USER';
export const INVITE_USER                            = 'INVITE_USER';
export const ADD_USER                               = 'ADD_USER';
export const STAGE_USER_FOR_DELETE                  = 'STAGE_USER_FOR_DELETE';
export const UNSTAGE_USERS_FOR_DELETE               = 'UNSTAGE_USERS_FOR_DELETE';
export const DELETE_USER                            = 'DELETE_USER';
export const ERROR_DELETE_USER                      = 'ERROR_DELETE_USER';

// Licenses
export const RECEIVE_LICENSES                       = 'RECEIVE_LICENSES';
export const RECEIVE_FEATURES                       = 'RECEIVE_FEATURES';
export const RECEIVE_USER_LICENSE_ASSIGNMENTS       = 'RECEIVE_USER_LICENSE_ASSIGNMENTS';
export const RECEIVE_ENTERPRISE_LICENSE_ASSIGNMENTS = 'RECEIVE_ENTERPRISE_LICENSE_ASSIGNMENTS';
export const RECEIVE_LICENSE_ASSIGNMENT_LIST        = 'RECEIVE_LICENSE_ASSIGNMENT_LIST';

// Modals
export const SET_QUESTION                           = 'SET_QUESTION';
export const RESET_QUESTION                         = 'RESET_QUESTION';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js